import { Modal } from 'flowbite';
import type { ModalOptions, ModalInterface } from 'flowbite';
import type { InstanceOptions } from 'flowbite';

const $modalElement: HTMLElement = document.querySelector('#browser-support-modal');

const modalOptions: ModalOptions = {
    placement: 'center',
    backdrop: 'dynamic',
    closable: false,
    onHide: () => {
        console.log('modal is hidden');
    },
    onShow: () => {
        console.log('modal is shown');
    },
    onToggle: () => {
        console.log('modal has been toggled');
    },
};

// instance options object
const instanceOptions: InstanceOptions = {
  id: 'modalEl',
  override: true
};

const modal: ModalInterface = new Modal($modalElement, modalOptions, instanceOptions);

if (!('serial' in navigator)) {
    modal.show();
}
